// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__Lv8II","Logo":"Auth_Logo__nvBs1","Title":"Auth_Title__00O+1","Error":"Auth_Error__CO5tH"};